export default __webpack_public_path__ + "static/media/regulatory--no-rickshaws--g3.ac5bec9d.png";